var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.selectList,
      label: _vm.lable,
      "item-text": "TimeSeriesName",
      rules: _vm.timeSeriesRule,
      "return-object": "",
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function (data) {
          return [
            typeof data.item !== "object"
              ? [
                  _c("v-list-tile-content", {
                    domProps: { textContent: _vm._s(data.item) },
                  }),
                ]
              : [
                  _c(
                    "v-list-tile-avatar",
                    [_c("v-icon", [_vm._v("satellite")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", {
                        domProps: {
                          innerHTML: _vm._s(data.item.TimeSeriesName),
                        },
                      }),
                    ],
                    1
                  ),
                ],
          ]
        },
      },
    ]),
    model: {
      value: _vm.outputData,
      callback: function ($$v) {
        _vm.outputData = $$v
      },
      expression: "outputData",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }